/**
 * 로그인한 공급사 본인의 회사 정보 — 견적서 작성 창의 «공급자» 칸.
 *
 * 판매자 대시보드(직접 로그인)는 `/auth/me` 만 읽어 회사 정보가 없었고, 그래서 대시보드에서 연
 * 견적서 작성 창의 등록번호·상호·성명·주소·업태·담당자가 전부 «알 수 없음» 이었다(V-05·A3-12).
 * 임베드 경로는 토큰 교환 응답에 같은 정보가 실려 와 정상이었다.
 *
 * ⚠️ Authorization 헤더를 직접 만들지 않는다 — axios 인스턴스 기본 헤더(setAuthToken)가 정본이다.
 */
import { useQuery } from "@tanstack/react-query";
import { instance, type SupplierInfoDto } from "@semo/api-contracts";

interface Envelope<T> {
  data: T;
}

export const MY_SUPPLIER_INFO_QUERY_KEY = [
  "vendor",
  "my-supplier-info",
] as const;

export async function fetchMySupplierInfo(): Promise<SupplierInfoDto> {
  const response = await instance.get<Envelope<SupplierInfoDto>>(
    "/api/v1/external/suppliers/me",
  );
  return response.data.data;
}

export function useMySupplierInfo(options: {
  enabled: boolean;
  userId?: string;
}) {
  return useQuery({
    queryKey: [...MY_SUPPLIER_INFO_QUERY_KEY, options.userId ?? null],
    queryFn: fetchMySupplierInfo,
    enabled: options.enabled,
    staleTime: 1000 * 60 * 5,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
